import React from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import Dashboard from './Layout/dashboard'
import Login from './pages/Login/Login'
import MatchList from './pages/matchlist'
import User from './pages/user'
import Poll from './pages/Prediction/Poll'
import OpinionPro from './pages/Prediction/OpinionPro'
import InPlay from './pages/Prediction/InPlay'
import Skiller from './pages/Prediction/Skiller'
import SubAdmin from './pages/Admin/SubAdmin'
import Trading from './pages/Prediction/Trading'
import PredictionPriceBreakup from './pages/Prediction/PredictionPriceBreakup'
import PredictionChildView from './pages/Prediction/PredictionChildView'
import UserWinning from './pages/Prediction/users_winning'
import ProtectedRoute from './Layout/ProtectedRoute'
import { isEmpty } from 'lodash'
import PriceBreakUpList from './pages/PriceBreakup/PriceBreakupList'
import { ACCESS_LEVEL } from './constant/constant'
import { useSelector } from 'react-redux'
import PredictionManager from './pages/PredictionManager/PredictionManager'
import { Category } from './pages/category/category'
import { CategoryDetails } from './pages/category/categoryDetails'
import Gst from './pages/Gst/Gst'
import { GlobalManager } from './pages/Prediction/Global'
import FinishedPredictionGst from './pages/finishedPredictionGst'
import { SuspendInPlay } from './pages/Prediction/suspendInPlay'
import { SuspendInPlayContest } from './pages/Prediction/suspendInPlayContest'
import { HoldTradingMatching } from './pages/Prediction/holdTrading'
import jwtDecode from 'jwt-decode'
import MatchVerifier from './pages/MatchVerifier/matchVerifier'
import BotMatchList from './pages/matchlistForHold'
import TradingBot from './pages/Prediction/botTrading'
import UserCommissionViewer from './pages/AdminCommission'
import UpdateGlobalData from './pages/Update_Global_Data'
import SeriesMatchList from './pages/SeriesMatchList'
import CategoryLogo from './pages/categoryLogo'
import CreateExpiry from './pages/cashBackExpiry'


function Router() {
    const accessCokies = useSelector(state => state.loginSlice)
    const getAfterLoginRoute = () => {
        if (accessCokies.token) { 
        let data = jwtDecode(accessCokies.token)
        if (data.accessLevel === ACCESS_LEVEL.CUSTOMER_SUPPORT)
            return "/prediction-manager"
        return "/matchlist"
    }
    }
    const getAfterLoginRouteBot = () => {
        if (accessCokies.token) { 
        let data = jwtDecode(accessCokies.token)
        if (data.accessLevel === ACCESS_LEVEL.HOLDTRADING)
            return "/bot-matchlist"
        return "/matchlist"
    }
    }

    const getAfterLoginRouteCommission = () => {
        if (accessCokies.token) { 
        let data = jwtDecode(accessCokies.token)
        if (data.accessLevel === ACCESS_LEVEL.SUB_ADMIN3)
            return "/admin-commission"
        return "/matchlist"
    }
    }

    const Route = useRoutes([
        {
            
            element: <Dashboard />,
            children: [
                {
             
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.SUB_ADMIN3}/>, 
                    children:[
                        {
                            path: '/',
                            element: <Navigate to={getAfterLoginRouteCommission()} replace={true} />,
                        },
                        {   
                            path:'/admin-commission',
                            exact: true, 
                            element :<UserCommissionViewer />,
                        },
                    
                    ]
                },
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.HOLDTRADING}/>, 
                    children: [
                        {
                            path: '/',
                            element: <Navigate to={getAfterLoginRouteBot()} replace={true} />,
                        },
                        { path: '/bot-matchlist',
                          exact: true, 
                          element: <BotMatchList/>
                        },
                        {
                            path:'/matchlist/trading-bot/:match_id/:series_id/:sport',
                            element :<TradingBot />,
                        }
                         
                    ]
                },
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.CUSTOMER_SUPPORT}/>, 
                    children: [
                        {
                            path: '/',
                            element: <Navigate to={getAfterLoginRoute()} replace={true} />,
                        },
                         { path: '/prediction-manager',
                          exact: true, 
                          element: <PredictionManager/>
                        },
                    ]
                },
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.SUB_ADMIN2}/>, 
                    children:[
                        // {
                        //     path: '/',
                        //     element: <Navigate to="/matchlist" replace={true} />,
                        // },
                        {   
                            path:'/matchlist',
                            element :<MatchList />,
                        },
                        {   
                            path:'/price-breakup-list',
                            element :<PriceBreakUpList />,
                        },{
                            path:'/matchlist/poll/:match_id/:series_id/:sport',
                            element :<Poll />,
                        },{
                            path:'/matchlist/opinion_pro/:match_id/:series_id/:sport',
                            element :<OpinionPro />,
                        },{
                            path:'/matchlist/prediction_child/:match_id/:series_id/:prediction_id',
                            element :<PredictionChildView />,
                        },{
                            path:'/matchlist/trading/:match_id/:series_id/:sport',
                            element :<Trading />,
                        },
                        // {
                        //     path:'/matchlist/in_play/:match_id/:series_id/:sport',
                        //     element :<InPlay />,
                        // },
                        // {
                        //     path:'/matchlist/in_play/:match_id/:series_id/:sport/:pred_id/suspend',
                        //     element :<SuspendInPlay />,
                        // },
                        // {
                        //     path:'/matchlist/in_play/:match_id/:series_id/:sport/:pred_id/suspend/contest',
                        //     element :<SuspendInPlayContest />,
                        // },
                        {
                            path:'/matchlist/skiller/:match_id/:series_id/:sport',
                            element :<Skiller />,
                        },
                        {
                            path:'/add_breakup/prediction/:match_id/:series_id/:_id',
                            exact: true,
                            element :<PredictionPriceBreakup />,
                        },
                        {
                            path:'/contests_schedule/prediction_child/:match_id/:series_id/:prediction_id',
                            exact: true,
                            element :<PredictionChildView />,
                        },
                        
                        {
                            path:'/user_winning/:prediction_id',
                            exact: true,
                            element :<UserWinning />,
                        },
                        {
                            path:'/user',element :<User />
                        },
                        {
                            path:'/sub-admin',element : <SubAdmin/>
                        },
                        { path: '/add_breakup/prediction/:match_id/:series_id/:_id',
                          exact: true, 
                          component: PredictionPriceBreakup 
                        },
                        // { path: '/prediction-manager',
                        //   exact: true, 
                        //   element: <PredictionManager/>
                        // },
                        { path: '/category',
                          exact: true, 
                          element: <Category/>
                        },
                        { path: '/category/:match_id',
                          exact: true, 
                          element: <CategoryDetails/>
                        },
                        { path: '/global',
                          exact: true, 
                          element: <GlobalManager />
                        },
                        {   
                            path:'/series-matches',
                            element :<SeriesMatchList />,
                        },
                         {   
                            path:'/category-logo',
                            element :<CategoryLogo />,
                        },
                        {   
                            path:'/cashback-expiry',
                            element :<CreateExpiry />,
                        },
                    ]
                },
               
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.ADMIN}/>, 
                    children:[
                        {
                            path:'/user',element :<User />
                        },
                        {
                            path:'/sub-admin',element : <SubAdmin/>
                        },
                        {
                            path:'/match_data',element : <FinishedPredictionGst />
                        },
                        { path: '/match_data/:match_id',
                          exact: true, 
                          element: <Gst />
                        },
                        {
                            path:'/matchlist/in_play/:match_id/:series_id/:sport',
                            element :<InPlay />,
                        },
                        {
                            path:'/matchlist/in_play/:match_id/:series_id/:sport/:pred_id/suspend',
                            element :<SuspendInPlay />,
                        },
                        {
                            path:'/matchlist/in_play/:match_id/:series_id/:sport/:pred_id/suspend/contest',
                            element :<SuspendInPlayContest />,
                        },
            
                        {
                            path:'/matchlist/trading/:match_id/:series_id/:sport/:pred_id/hold',
                            element :<HoldTradingMatching />,
                        },
                        {
                             path: '/match-verifier',
                            element: <MatchVerifier/>
                          
                        },
                        {   
                            path:'/admin-commission',
                            element :<UserCommissionViewer />,
                        },
                        {   
                            path:'/update-global-data',
                            element :<UpdateGlobalData />,
                        },
                    ]
                },
            ]
        },
        {
            path: "/login",
            element: !isEmpty(accessCokies.token) ? <Navigate to="/" replace={true} /> : <Login />,
        }

    ])
    return Route
}

export default Router


// staging 